export const envConfigs = {
  supabase: {
    url: process.env.NEXT_PUBLIC_SUPABASE_URL,
    key: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY,
  },
};

export const bankingConfig = {
  bankName: 'Cardone Capvest Bank',
  accountNumber: process.env.BANK_ACCOUNT_NUMBER || '••••••••••••1234',
  routingNumber: process.env.BANK_ROUTING_NUMBER || '•••••••••••4321',
  reference: 'Your Full Name',
};
